"use client";

import * as React from "react";

type CloudflareSafeEmailLinkProps = {
  localPart: string;
  domain: string;
  className?: string;
};

export default function CloudflareSafeEmailLink({
  localPart,
  domain,
  className,
}: CloudflareSafeEmailLinkProps) {
  const [isHydrated, setIsHydrated] = React.useState(false);

  React.useEffect(() => {
    setIsHydrated(true);
  }, []);

  const email = `${localPart}@${domain}`;

  if (!isHydrated) {
    return (
      <span className={className} aria-label={`${localPart} at ${domain}`}>
        {localPart} [at] {domain}
      </span>
    );
  }

  return (
    <a href={`mailto:${email}`} className={className}>
      {email}
    </a>
  );
}
